export default {
    computed: {
        queriedData() {
            if (this.sort !== null && this.sort.charAt(0) === '-') {
                this.tableData.reverse()
            }
            return this.tableData;
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.meta.total < highBound) {
                highBound = this.meta.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
    },
    data() {
        return {
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            },
            defaultSort: null,
            sort: null,
            searchQuery: '',
            meta: {},
        }
    },
    methods: {
        setMeta(data) {
            this.meta = data;
            this.pagination.total = data.total;
        },
        changePage(page) {
            // TODO refactorizar
            if (this.pagination.total > 0 && this.initialized) {
                this.pagination.currentPage = page;
                this.fetchTableData();
            }
        },
        sortChange({prop, order}) {
            if (order === 'ascending') {
                this.sort = prop;
            } else if (order === 'descending') {
                this.sort = `-${prop}`;
            } else {
                this.sort = null;
            }

            this.fetchTableData();
            this.scrollToTop();
        },
    },
    watch: {
        searchQuery() {
            let savedQuery = this.searchQuery;

            setTimeout(() => {
                if (this.searchQuery === savedQuery) {
                    this.fetchTableData();
                }
            }, 1000)
        }
    }
}
